var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#3BA358"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9305 15.0004C10.862 15.0002 10.7942 14.9859 10.7314 14.9584C10.6686 14.9309 10.6122 14.8907 10.5655 14.8404L8.13553 12.2554C8.04469 12.1586 7.99603 12.0297 8.00025 11.897C8.00447 11.7644 8.06123 11.6388 8.15803 11.5479C8.25484 11.4571 8.38376 11.4084 8.51644 11.4127C8.64912 11.4169 8.77469 11.4736 8.86553 11.5704L10.9255 13.7654L15.1305 9.16544C15.1732 9.1123 15.2263 9.06845 15.2865 9.03658C15.3468 9.0047 15.4129 8.98548 15.4808 8.98008C15.5488 8.97469 15.6171 8.98324 15.6816 9.00522C15.7461 9.02719 15.8055 9.06212 15.856 9.10787C15.9065 9.15361 15.9471 9.2092 15.9754 9.27121C16.0036 9.33323 16.0189 9.40037 16.0203 9.46851C16.0216 9.53665 16.0091 9.60435 15.9833 9.66745C15.9576 9.73055 15.9192 9.78772 15.8705 9.83544L11.3005 14.8354C11.2544 14.8866 11.1981 14.9277 11.1353 14.9561C11.0725 14.9845 11.0045 14.9996 10.9355 15.0004H10.9305Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.8da3961d40c06d4cc1844be438332449.svg";
export { ForwardRef as ReactComponent };